import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { InputField } from "../../../atoms/InputField";
import Button from "../../../atoms/Button";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import { useDeviceType } from "../../../custom-hooks/useDeviceType";

import "./search-entity.m.css";

const SearchEntity = ({ entityName, onResults }) => {
  const isMobile = useDeviceType();
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  const limit = 16;
  let plText = entityName;
  if (entityName === "person") {
    plText = "people";
  }
  const handleSearch = async () => {
    if (query.trim().length < 3) return;

    try {
      setLoading(true);
      const entityUrl = `/api/v1/entities?q=${encodeURIComponent(query)}&limit=${limit}&type=${entityName}`;
      const res = await fetch(entityUrl);
      const data = await res.json();
      onResults(data.entities || []);
    } catch (err) {
      console.error("Error fetching:", err);
      onResults([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div styleName="search-entity">
      <div styleName="input-wrapper">
        <div styleName="input-icon-wrapper">
          <InputField
            styleName="search-input"
            value={query}
            placeholder={`Search for ${plText}`}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
          {isMobile !== "mobile" && (
            <SvgIconHandler type="search-gray-color" width="32" height="32" className="svg-icon" />
          )}
        </div>
        <Button styleName="search-button" onClick={handleSearch}>
          {isMobile === "mobile" ? (
            <SvgIconHandler type="search" width="32" height="32" className="svg-icon" />
          ) : (
            "SEARCH"
          )}
        </Button>
      </div>
    </div>
  );
};
export default SearchEntity;
